const base = "rounded-lg  px-4 w-full h-full focus:outline-none focus:ring-0 ";

const inputClass = {
  error: `${base}`,
  base: base,
};

export default inputClass;
